import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { SidResponseVerify } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import {
  formatDateString,
  formatFullName,
} from '@sdir/blueprint.aps/lib/helpers/formattingHelpers';
import { styles } from '@sdir/sds';

interface SidProps {
  sid?: SidResponseVerify;
}

const Sid: React.FC<SidProps> = ({ sid }) => {
  const intl = useIntl();
  const fullName = formatFullName(sid?.firstName, sid?.middleName || '', sid?.lastName);
  return (
    <Wrapper>
      <h2>{intl.formatMessage({ id: 'sid.title' })}</h2>
      <Row>
        <span>{intl.formatMessage({ id: 'status' })}</span>
        <span>{intl.formatMessage({ id: sid?.isValid ? 'sid.valid' : 'sid.invalid' })}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'name' })}</span>
        <span>{fullName || ''}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'birthnumber' })}</span>
        <span>{sid?.dateOfBirth ? formatDateString(sid.dateOfBirth) : ''}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'sid.issueddate' })}</span>
        <span>{sid?.issuedDate ? formatDateString(sid.issuedDate) : ''}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'expirydate' })}</span>
        <span>{sid?.expiryDate ? formatDateString(sid.expiryDate) : ''}</span>
      </Row>
    </Wrapper>
  );
};

export default Sid;

const Wrapper = styled.div`
  background-color: #ffffff;
  box-shadow: ${styles.card.boxShadow};
  margin: 30px 0;
  padding: 30px;
  max-width: 400px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  span:first-child {
    font-weight: bold;
  }
`;
